import { Color } from "@repo/app-types/constants/colors";
import { Size } from "@repo/ui/helpers/helpers";
import { Pill } from "@repo/ui/Pills/pill";
import type { FC } from "react";

interface DraftStatusPillProps {
  /** True if the draft matches the live revision */
  isLive: boolean;
}

/**
 * Displays a "Draft" pill when there are unpublished changes.
 * Returns null when the draft is live (no changes).
 */
export const DraftStatusPill: FC<DraftStatusPillProps> = ({ isLive }) => {
  if (isLive) {
    return null;
  }

  return <Pill label="Draft" size={Size.SMALL} color={Color.Amber} />;
};
